export enum MigrationTypes {
  'upsert' = 'upsert',
  'upsert selected' = 'upsert selected',
  'replace' = 'replace',
}
